
export const BulckWithdrawStatusUpload = (data) => {
    var formdata = new FormData()
    console.log(data);

    if(data.attachments){
        formdata.append('attachments',data.attachments.rawFile)
    }

    if(data.status){
        formdata.append('status',data.status)
    }

    return formdata;
}